import React from 'react';

import { Box, Card, Button, Typography } from '@mui/material';

import { ChannelStepLayout } from 'src/pages/channel/shared/channel-step-layout';

import { useEmailStep5 } from '../hooks/useEmailStep5';

export function EmailStep5() {
  const { state, t, codeString, copyTextHandler } = useEmailStep5();

  return (
    <ChannelStepLayout title="">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {state?.channelType !== 'LIVE_CHAT' && (
          <Typography variant="body2" sx={{ color: 'text.disabled' }}>
            {t('START_FORWARDING_EMAILS')}
          </Typography>
        )}
        {state?.channelType === 'LIVE_CHAT' && (
          <Box sx={{ width: { xs: '100%', md: '60%' }, textAlign: 'center', margin: '0 auto' }}>
            <Typography variant="h3" sx={{ textAlign: 'center', mb: 3 }}>
              {t('CHANNEL_CREATED_SUCCESSFULLY')}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.disabled' }}>
              {t('LIVE_CHAT_MESSAGE')}
            </Typography>
          </Box>
        )}

        <Card
          sx={{
            m: { xs: 0, md: 2 },
            px: { xs: 2, md: 4 },
            py: 2,
            width: { xs: '100%', md: 'auto' },
            maxWidth: '100%',
            display: 'flex',
            gap: 2,
            alignItems: 'flex-start',
            marginTop: '16px',
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflowX: 'auto',
              width: { xs: '100%', md: '800px' },
              maxWidth: '100%',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                background: 'primary.light',
                padding: '1rem',
                pt: { xs: 5, sm: '1rem' },
                borderRadius: '8px',
                overflowX: 'auto',
                fontSize: '0.75rem',
              }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={copyTextHandler}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  fontSize: '0.7rem',
                  px: 1.5,
                  py: 0.25,
                  textTransform: 'uppercase',
                }}
              >
                {t('COPY')}
              </Button>
              <pre
                style={{
                  margin: 0,
                  width: '100%',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                <code>{codeString}</code>
              </pre>
            </Box>
          </Box>
        </Card>

        {state?.channelType !== 'LIVE_CHAT' && (
          <Button size="small" sx={{ py: 2 }} variant="outlined" onClick={() => {}}>
            {t('MORE_SETTINGS')}
          </Button>
        )}
      </Box>
    </ChannelStepLayout>
  );
}
